import { Box, Td, useToast } from "@chakra-ui/react";
import React from "react";
import CreateTable from "../components/common/Table/Table";
import Loading from "../components/common/ui/Loading";
import Fallback from "../components/common/ui/Fallback";
import { useNavigator } from "../hooks/useNavigator";
import { getLanguage } from "../utils/api";
import LanguageModal from "../components/LanguageModal";

const Languages = () => {
  const [loading, setLoading] = React.useState(false);
  const [languages, setLanguages] = React.useState([]);
  const toast = useToast();
  
  const getAllLanguagesHandler = async () => {
    setLoading(true);
    if (
      user?.getSeries ||
      user?.addSeries ||
      user?.getMovies ||
      user?.addMovies
    ) {
      const [success, data] = await getLanguage();
      if (success) {
        setLanguages(data);
      } else {
        const errorMessage = 
          data?.response?.data?.message || 
          data?.message || 
          data?.response?.data?.error ||
          (typeof data === 'string' ? data : 'Failed to fetch languages');
        toast({
          title: "Error",
          description: errorMessage,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
    setLoading(false);
  };

  const [navigate, user] = useNavigator(() => {
    if (user) {
      getAllLanguagesHandler();
    } else {
      navigate("/login");
    }
  });

  if (loading) {
    return <Loading />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
        padding: "1rem",
      }}
    >
      {user?.getSeries ||
      user?.addSeries ||
      user?.getMovies ||
      user?.addMovies ? (
        <>
          <LanguageModal title="Add Language" reload={getAllLanguagesHandler} />
          <CreateTable
            data={languages}
            head={["Name", "id"]}
            rows={(row) => {
              return (
                <>
                  <Td>{row.name}</Td>
                  <Td>{row._id}</Td>
                  <Td>
                    <LanguageModal
                      title="Edit"
                      update={row}
                      reload={getAllLanguagesHandler}
                    />
                  </Td>
                </>
              );
            }}
          />
        </>
      ) : (
        <Fallback />
      )}
    </Box>
  );
};

export default Languages;

